/**
 * Authentication Configuration
 * 
 * Add users here with their credentials.
 * For production, consider using environment variables or a backend service.
 */

const authConfig = {
    // List of valid users
    users: [
        { username: 'admin', password: 'admin123' },
        { username: 'user', password: 'user123' },
    ],

    // Session storage key
    sessionKey: 'svg_mapper_auth',

    // Session expiry in hours (0 = never expires)
    sessionExpiryHours: 24,
};

export default authConfig;
